import { useEffect, createContext, useState, useRef, useContext } from "react";

const WebSocketContext = createContext(null);

export const useWebSocketContext = () => {
    return useContext(WebSocketContext);
}; 

export const WebSocketContextProvider = ({ children }) => {
    const [socketData, setSocketData] = useState([]);
    const [isConnected, setIsConnected] = useState(false);
    const storedToken = localStorage.getItem("token");
    const [updateVersion, setUpdateVersion] = useState(0);
    const wsRef = useRef(null);

    useEffect(() => {
        const wsUrl = `wss://np5l7xfam7.execute-api.us-east-1.amazonaws.com/dev/?token=${storedToken}`;
        let reconnectTimeout = null;

        const connectWebSocket = () => {
            wsRef.current = new WebSocket(wsUrl);

            wsRef.current.onopen = () => {
              //  console.log("✅ WebSocket connection established!");
                setIsConnected(true);
            };

            wsRef.current.onmessage = (event) => {
                try {
                    const newData = JSON.parse(event.data);

                    // Normalize store_id to string
                    const newStoreId = typeof newData?.store_id === "object" && newData?.store_id?._id
                        ? newData?.store_id?._id
                        : newData?.store_id;

                    // Ensure newData.store_id is now string
                    newData.store_id = newStoreId; 

                    setSocketData((prevData) => {
                        const updated = prevData.map(item => {
                            const itemStoreId = typeof item?.store_id === "object" ? item?.store_id?._id : item?.store_id;
                            return itemStoreId === newStoreId ? newData : item;
                        }); 

                        const exists = updated.some(item => {
                            const id = typeof item?.store_id === "object" ? item?.store_id?._id : item.store_id;
                            return id === newStoreId;
                        });

                        const finalData = exists ? updated : [...updated, newData];
                      //  console.log("🔁 Updated socketData:", finalData);
                        setUpdateVersion(v => v + 1);
                        return finalData;
                    });

                } catch (error) {
                    console.error("❌ Error parsing WebSocket message:", error);
                }
            };

            wsRef.current.onerror = (error) => {
                console.error("⚠️ WebSocket error:", error);
            };

            wsRef.current.onclose = () => {
              //  console.log("🔌 WebSocket connection closed");
                setIsConnected(false);
                reconnectTimeout = setTimeout(connectWebSocket, 5000); // Auto-reconnect after 5s
            };
        };

        connectWebSocket();

        return () => {
            if (reconnectTimeout) clearTimeout(reconnectTimeout);
            if (wsRef.current) wsRef.current.close();
        };
    }, [storedToken]);

    return (
        <WebSocketContext.Provider value={{ socketData, isConnected, updateVersion }}>
            {children}
        </WebSocketContext.Provider>
    );
};
